import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React, { useState } from "react";

import ContentContainer from "~/components/layout/ContentContainer";
import SectionWrapper from "~/components/layout/SectionWrapper";

import IconOnlyButton from "~/components/buttons/IconOnlyButton";

import UnderlineTitle from "~/components/typography/UnderlineTitle";

import { h1 } from "~/styles/typographyStyles";

import { sanitizeAndParseHTML } from "~/utilities/helpers";

import useUrlManager from "~/hooks/useUrlManager";

const StyledContentContainer = styled(ContentContainer)`
    display: flex;
    justify-content: center;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    text-align: center;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
        width: 50vw;
    }
`;

const Title = styled.h1`
    ${h1};
`;

const Copy = styled.div`
    margin-bottom: ${({ theme }) => theme.layout.paragraphSpacing};
`;

const Form = styled.form`
    width: 100%;
    max-width: 600px;
    position: relative;
`;

const Input = styled.input`
    width: 100%;
    background-color: ${({ theme }) => theme.palette.white};
    border: 1px solid transparent;
    border-radius: 32px;
    font-weight: 600;
    padding: 20px;

    &::placeholder {
        opacity: 50%;
    }
`;

const StyledIconButton = styled(IconOnlyButton)`
    position: absolute;
    top: 30%;
    right: 5%;
`;

const PageHeader404 = ({
    copy = "",
    subtitle = "",
    title,
    noMarginBottom = false,
}) => {
    const [searchInput, setSearchInput] = useState(null);
    const { getUpdateUrlFunc } = useUrlManager();
    const updateUrl = getUpdateUrlFunc();

    const handleSubmit = (e) => {
        e.preventDefault();
        updateUrl(`/search?q=${searchInput}`);
    };

    return (
        <SectionWrapper
            backgroundColor="gray"
            withPadding
            {...{ noMarginBottom }}
        >
            <StyledContentContainer>
                <Wrapper>
                    {subtitle ? (
                        <UnderlineTitle>{subtitle}</UnderlineTitle>
                    ) : null}

                    <Title>{title}</Title>

                    {copy ? <Copy>{sanitizeAndParseHTML(copy)}</Copy> : null}

                    <Form onSubmit={handleSubmit}>
                        <Input
                            id="search-input"
                            type="text"
                            name="search"
                            placeholder="Type to search"
                            onChange={(e) => {
                                e.preventDefault();
                                setSearchInput(e.target.value);
                            }}
                        />
                        <StyledIconButton
                            icon="search"
                            iconLibrary="fas"
                            screenReaderText="Click to search"
                            type="Submit"
                            onClick={handleSubmit}
                        />
                    </Form>
                </Wrapper>
            </StyledContentContainer>
        </SectionWrapper>
    );
};

PageHeader404.propTypes = {
    copy: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    noMarginBottom: PropTypes.bool,
};

export default PageHeader404;
